import React, { FC, memo, useCallback } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Dialog } from '@ucheba/ui/components/Dialog/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { useDialog } from '@ucheba/ui/components/Dialog/bll'
import { ESpecialitiesDataKeys } from '@ucheba/store/specialities/search/types'
import { useSpecialitiesPageSearchByEgeCore } from '../bll'
import { FormSelectEge } from '../../../../../components/FormSelectEge/desktop'
import data from '../data.json'

const SpecialitiesPageSearchByEge: FC = () => {
  const { egeList, onOpenSearchByEgeEge, onSubmitSearchByEgeEge } =
    useSpecialitiesPageSearchByEgeCore()
  const { searchByEge } = data

  const dialogSearchByEgeEge = useDialog('dialog__search-by-ege')
  const onFormSubmit = useCallback(
    (args) => {
      onSubmitSearchByEgeEge(args)
      dialogSearchByEgeEge.closeDialog()
    },
    [dialogSearchByEgeEge, onSubmitSearchByEgeEge]
  )

  return (
    <>
      <Button color='blue' onClick={dialogSearchByEgeEge.openDialog}>
        {searchByEge.activator}
      </Button>

      <Dialog
        open={dialogSearchByEgeEge.isActive}
        onClose={dialogSearchByEgeEge.closeDialog}
        onOpen={onOpenSearchByEgeEge}
        spacing='xlarge'
      >
        <Heading h2={searchByEge.desktop.title} spacing='xlarge' />

        <FormSelectEge
          egeList={egeList}
          name={ESpecialitiesDataKeys.examSubjectIds}
          buttonText={searchByEge.desktop.buttonText}
          onSubmit={onFormSubmit}
        />
      </Dialog>
    </>
  )
}

export default memo(SpecialitiesPageSearchByEge)
